var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    class: _vm.classes,
    attrs: {
      "view-box": _vm.spinnerSVG.viewBox,
      "aria-label": _vm.accessibilityLabel,
      "role": "status"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.spinnerSVG.body)
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-a4b3e3ec", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a4b3e3ec","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PolarisSpinner.vue
// module id = 119
// module chunks = 0